import { MaterialId } from '@core/constants/Material';

export const allEngineeredWoods: MaterialId[] = [
    MaterialId.OakRegularEngineered,
    MaterialId.BeechEngineered,
    MaterialId.PineEngineered,
    MaterialId.WalnutEngineered,
    MaterialId.AshEngineered,
    MaterialId.AshOliveEngineered,
    MaterialId.ChestnutEngineered,
    MaterialId.AcaciaEngineered,
    MaterialId.MahoganyEngineered,
    MaterialId.ElmEngineered,
    MaterialId.AlderwoodEngineered,
    MaterialId.BirchEngineered,
    MaterialId.MapleEngineered,
    MaterialId.TeakEngineered,
    MaterialId.WengeEngineered,
    MaterialId.CherrywoodEngineered,
    MaterialId.EbonyEngineered,
    MaterialId.SpruceEngineered,
    MaterialId.PoplarEngineered,
    MaterialId.IpeEngineered,
    MaterialId.PadoukEngineered,
    MaterialId.LarchEngineered,
    MaterialId.RedcedarEngineered,
    MaterialId.DouglasEngineered,
];

export const allRecycledWoods: MaterialId[] = [
    MaterialId.OakRegularRecycled,
    MaterialId.BeechRecycled,
    MaterialId.PineRecycled,
    MaterialId.WalnutRecycled,
    MaterialId.AshRecycled,
    MaterialId.AshOliveRecycled,
    MaterialId.ChestnutRecycled,
    MaterialId.AcaciaRecycled,
    MaterialId.MahoganyRecycled,
    MaterialId.ElmRecycled,
    MaterialId.AlderwoodRecycled,
    MaterialId.BirchRecycled,
    MaterialId.MapleRecycled,
    MaterialId.TeakRecycled,
    MaterialId.WengeRecycled,
    MaterialId.CherrywoodRecycled,
    MaterialId.EbonyRecycled,
    MaterialId.SpruceRecycled,
    MaterialId.RubberRecycled,
    MaterialId.DriftWoodRecycled,
    MaterialId.PoplarRecycled,
    MaterialId.IpeRecycled,
    MaterialId.PadoukRecycled,
    MaterialId.LarchRecycled,
    MaterialId.RedcedarRecycled,
    MaterialId.DouglasRecycled,
];

export const allVeneerWoods: MaterialId[] = [
    MaterialId.OakRegularVeneer,
    MaterialId.BeechVeneer,
    MaterialId.PineVeneer,
    MaterialId.WalnutVeneer,
    MaterialId.AshVeneer,
    MaterialId.AshOliveVeneer,
    MaterialId.ChestnutVeneer,
    MaterialId.AcaciaVeneer,
    MaterialId.MahoganyVeneer,
    MaterialId.ElmVeneer,
    MaterialId.AlderwoodVeneer,
    MaterialId.BirchVeneer,
    MaterialId.MapleVeneer,
    MaterialId.TeakVeneer,
    MaterialId.WengeVeneer,
    MaterialId.CherrywoodVeneer,
    MaterialId.EbonyVeneer,
    MaterialId.SpruceVeneer,
    MaterialId.PoplarVeneer,
    MaterialId.IpeVeneer,
    MaterialId.PadoukVeneer,
    MaterialId.LarchVeneer,
    MaterialId.RedcedarVeneer,
    MaterialId.DouglasVeneer,
];

export const allSolidWoods: MaterialId[] = [
    MaterialId.OakRegular,
    MaterialId.Beech,
    MaterialId.Pine,
    MaterialId.WagonfloorDark,
    MaterialId.WagonfloorLight,
    MaterialId.OakOld,
    MaterialId.Walnut,
    MaterialId.Ash,
    MaterialId.AshOlive,
    MaterialId.Chestnut,
    MaterialId.Acacia,
    MaterialId.Mahogany,
    MaterialId.Elm,
    MaterialId.Alderwood,
    MaterialId.Birch,
    MaterialId.Maple,
    MaterialId.Teak,
    MaterialId.Wenge,
    MaterialId.Cherrywood,
    MaterialId.Ebony,
    MaterialId.Spruce,
    MaterialId.Rubber,
    MaterialId.DriftWood,
    MaterialId.Poplar,
    MaterialId.Ipe,
    MaterialId.Padouk,
    MaterialId.Larch,
    MaterialId.Redcedar,
    MaterialId.Douglas,
    MaterialId.Iroko,
    MaterialId.BlackLocust,
    MaterialId.Garapa,
];

export const allWoods: MaterialId[] = [
    ...allEngineeredWoods,
    ...allVeneerWoods,
    ...allRecycledWoods,
    ...allSolidWoods,
];

export const allCompositeWoods: MaterialId[] = [
    MaterialId.CompositeBlack,
    MaterialId.CompositeBrown,
    MaterialId.CompositeGrey,
    MaterialId.CompositeIpe,
    MaterialId.CompositeTaupe,
    MaterialId.CompositeTeak,
    MaterialId.CompositeWhite,
];

export const allMelaminedTone: MaterialId[] = [
    MaterialId.MelamineToneBeige,
    MaterialId.MelamineToneBrown,
    MaterialId.MelamineToneGrey,
    MaterialId.MelamineToneWhite,
];

export const allMelaminedClearWood: MaterialId[] = [
    MaterialId.MelamineLightAcacia,
    MaterialId.MelamineWhiteWood,
    MaterialId.MelamineSandChestnut,
    MaterialId.MelamineWhiteOak,
    MaterialId.MelamineNaturalOak,
    MaterialId.MelamineSandOak,
    MaterialId.MelamineChampagneMaple,
    MaterialId.MelamineSandAsh,
    MaterialId.MelamineWhiteLarch,
    MaterialId.MelamineWhiteElm,
    MaterialId.MelamineWhitePin,
    MaterialId.MelaminePolarPin,
];

export const allMelaminedDarkWood: MaterialId[] = [
    MaterialId.MelamineBarnWood,
    MaterialId.MelamineBlackWood,
    MaterialId.MelamineBlackBrownOak,
    MaterialId.MelamineChestnutOak,
    MaterialId.MelamineGrayOak,
    MaterialId.MelamineBlackOak,
    MaterialId.MelamineTabaccoOak,
    MaterialId.MelamineVintageOak,
    MaterialId.MelamineAnthraciteLarch,
    MaterialId.MelamineBrownLarch,
    MaterialId.MelamineGrayElm,
    MaterialId.MelamineGrayPine,
];

export const allMelaminedConcrete: MaterialId[] = [
    MaterialId.MelamineWhiteConcrete,
    MaterialId.MelamineBronzeConcrete,
    MaterialId.MelamineCefalConcrete,
    MaterialId.MelamineClearConcrete,
    MaterialId.MelamineClearGrayConcrete,
    MaterialId.MelamineDarkGrayConcrete,
];

export const allMelaminedMetal: MaterialId[] = [
    MaterialId.MelamineBrushedSteel,
    MaterialId.MelamineWroughtIronBronze,
    MaterialId.MelamineWroughtIronGrey,
    MaterialId.MelamineBrushedAluminium,
    MaterialId.MelamineAluminiumMetal,
    MaterialId.MelamineAnthraciteMetal,
    MaterialId.MelamineIndigoMetal,
    MaterialId.MelamineStainlessSteel,
    MaterialId.MelamineBrassMetal,
];

export const allMelaminedUniform: MaterialId[] = [
    MaterialId.MelamineBeigeUniform,
    MaterialId.MelamineChalkWhite,
    MaterialId.MelaminePolarWhite,
    MaterialId.MelamineClearBlueUniform,
    MaterialId.MelamineDarkBlueUniform,
    MaterialId.MelamineBlueUniform,
    MaterialId.MelamineBordeauxUniform,
    MaterialId.MelamineGrayArticUniform,
    MaterialId.MelamineDarkGrayUniform,
    MaterialId.MelamineYellowUniform,
    MaterialId.MelamineClearBrownUniform,
    MaterialId.MelamineDarkBrownUniform,
    MaterialId.MelamineNudeUniform,
    MaterialId.MelamineOrangeUniform,
    MaterialId.MelaminePinkUniform,
    MaterialId.MelamineRedUniform,
    MaterialId.MelamineTerracottaUniform,
    MaterialId.MelamineClearGreenUniform,
    MaterialId.MelamineDarkGreenUniform,
    MaterialId.MelamineGreenUniform,
    MaterialId.MelaminePurpleUniform,
    MaterialId.MelamineClearGrayUniform,
    MaterialId.MelamineBlackUniform,
];

export const allMelaminedMarble: MaterialId[] = [
    MaterialId.MelamineWhiteMarbleCarrarre,
    MaterialId.MelamineMarbleAnthraciteGrigia,
    MaterialId.MelamineMarbleBlackGrigia,
    MaterialId.MelamineMarbleWhiteLevanto,
];

export const allConcretes: MaterialId[] = [
    MaterialId.ConcreteFibred,
    MaterialId.ConcreteWaxed,
];

export const allMarbles: MaterialId[] = [
    MaterialId.MarbleArabescatoOribicoRosso,
    MaterialId.MarbleAzulImperial,
    MaterialId.MarbleBrecciaPontificia,
    MaterialId.MarbleBlackSahara,
    MaterialId.MarbleCalacatta,
    MaterialId.MarbleGrandAntiqueAubert,
    MaterialId.MarbleBrecheDeVendome,
    MaterialId.MarbleCarrare,
    MaterialId.MarbleForestBrown,
    MaterialId.MarbleMarquina,
    MaterialId.MarblePortLaurent,
    MaterialId.MarbleRosePortugal,
    MaterialId.MarbleSilverWave,
    MaterialId.MarbleStriatoOlimpico,
    MaterialId.MarbleTravertinClassicMedium,
    MaterialId.MarbleVerdeAlpi,
    MaterialId.MarbleVerdeGuatemala,
    MaterialId.MarbleWhiteBeauty,
];

export const allGranites: MaterialId[] = [
    MaterialId.GraniteAbsoluteBlackZimbabwe,
    MaterialId.GraniteAmazzonite,
    MaterialId.GraniteAzulAran,
    MaterialId.GraniteBalmoral,
    MaterialId.GraniteCambrianBlack,
    MaterialId.GraniteCoffeeBrown,
    MaterialId.GraniteCoralRed,
    MaterialId.GraniteGialloVeneziano,
    MaterialId.GranitePorrino,
    MaterialId.GraniteRosaBeta,
];

export const allQuartz: MaterialId[] = [
    MaterialId.QuartzImperialBrown,
    MaterialId.QuartzAzabache,
    MaterialId.QuartzBlackPortoro,
    MaterialId.QuartzBotticino,
    MaterialId.QuartzChorme,
    MaterialId.QuartzWhiteFusion,
    MaterialId.QuartzWhiteGalaxy,
    MaterialId.QuartzWhitePlatinium,
];

export const allStones: MaterialId[] = [
    MaterialId.StoneBlueHainot,
    MaterialId.StoneBourgogne,
    MaterialId.StoneLens,
    MaterialId.StoneLuserne,
    MaterialId.StoneSerpentinite,
    MaterialId.SlateGrey,
    MaterialId.SlateBlack,
];

export const allMelamine: MaterialId[] = [
    ...allMelaminedClearWood,
    ...allMelaminedDarkWood,
    ...allMelaminedConcrete,
    ...allMelaminedMarble,
    ...allMelaminedMetal,
    ...allMelaminedUniform,
    ...allMelaminedTone,
];

export const allMarbleAndStones: MaterialId[] = [
    ...allMarbles,
    ...allGranites,
    ...allQuartz,
    ...allStones,
];

export const allRivers: MaterialId[] = [
    MaterialId.RiverEpoxyBlackTransparent,
    MaterialId.RiverEpoxyBlueTransparent,
    MaterialId.RiverEpoxyWhiteTransparent,
    MaterialId.RiverEpoxyBlackOpaque,
    MaterialId.RiverEpoxyBlueOpaque,
    MaterialId.RiverEpoxyWhiteOpaque,
    MaterialId.RiverGlassBlackTransparent,
    MaterialId.RiverGlassBlueTransparent,
    MaterialId.RiverGlassWhiteTransparent,
    MaterialId.RiverGlassBlackOpaque,
    MaterialId.RiverGlassBlueOpaque,
    MaterialId.RiverGlassWhiteOpaque,
];

export const allGlasses: MaterialId[] = [
    MaterialId.Glass,
    MaterialId.GlassOpaque,
];

export const allMetals: MaterialId[] = [
    MaterialId.Steel,
    MaterialId.Aluminum,
    MaterialId.Rust,
    MaterialId.Brass,
    MaterialId.Iron,
    MaterialId.ThermoLaqueredBlack,
    MaterialId.ThermoLaqueredWhite,
    MaterialId.SheetMetal,
    MaterialId.StainlessSteel,
    MaterialId.Zinc,
    MaterialId.WroughtIron,
];

export const allColorsThermoLaquereds: MaterialId[] = [
    MaterialId.ThermoLaqueredGrey,
    MaterialId.ThermoLaqueredRed,
    MaterialId.ThermoLaqueredBlue,
    MaterialId.ThermoLaqueredYellow,
    MaterialId.ThermoLaqueredGreen,
    MaterialId.ThermoLaqueredPink,
    MaterialId.ThermoLaqueredOrange,
];

export const allPlastics: MaterialId[] = [
    MaterialId.PlexiglassFluorescent,
    MaterialId.PlexiglassFrosted,
    MaterialId.PlexiglassMirror,
    MaterialId.PlexiglassTransparent,
    MaterialId.PlexiglassWhite,
    MaterialId.PolycarbonateOpaque,
    MaterialId.PolycarbonateTeinted,
    MaterialId.PolycarbonateTransparent,
    MaterialId.Pvc,
    MaterialId.PvcRigid,
    MaterialId.RecycledPlastic,
];

export const allCorian: MaterialId[] = [
    MaterialId.CorianAnthracite,
    MaterialId.CorianBurledBeach,
    MaterialId.CorianBurled,
    MaterialId.CorianCocoaPrima,
    MaterialId.CorianCosmosPrima,
    MaterialId.CorianDeepBlackQuartz,
    MaterialId.CorianDusk,
    MaterialId.CorianEveningPrima,
    MaterialId.CorianGlacierWhite,
    MaterialId.CorianGrayOnyx,
    MaterialId.CorianHazelnut,
    MaterialId.CorianLimestonePrima,
    MaterialId.CorianLinen,
    MaterialId.CorianNimbusPrima,
    MaterialId.CorianStratus,
    MaterialId.CorianTumbleweed,
    MaterialId.CorianWhiteOnyx,
    MaterialId.CorianXitchHazel,
];

export const allDekton: MaterialId[] = [
    MaterialId.DektonDanae,
    MaterialId.DektonEther,
    MaterialId.DektonHelena,
    MaterialId.DektonKhalo,
    MaterialId.DektonKira,
    MaterialId.DektonKylia,
    MaterialId.DektonLaurent,
    MaterialId.DektonLiquidEmbers,
    MaterialId.DektonLiquidSky,
    MaterialId.DektonRem,
    MaterialId.DektonSoke,
    MaterialId.DektonStrato,
    MaterialId.DektonVienna,
    MaterialId.DektonWhiteConcrete,
];

export const allCeramics: MaterialId[] = [
    MaterialId.CeramicKadum,
    MaterialId.CeramicKeo,
    MaterialId.CeramicKeranium,
    MaterialId.CeramicManhattan,
    MaterialId.CeramicNilium,
    MaterialId.CeramicOrix,
    MaterialId.CeramicStrato,
    MaterialId.CeramicWhiteConcrete,
    ...allCorian,
    ...allDekton,
];

export const allMaterials: MaterialId[] = [
    ...allWoods,
    ...allCeramics,
    ...allConcretes,
    ...allMarbleAndStones,
    ...allRivers,
    ...allGlasses,
    ...allMetals,
    ...allMelamine,
    ...allPlastics,
];

export const allSlabOutDoor: MaterialId[] = [
    MaterialId.SlabOutdoorArdoise,
    MaterialId.SlabOutdoorCerameGres,
    MaterialId.SlabOutdoorConcrete,
    MaterialId.SlabOutdoorGranite,
    MaterialId.SlabOutdoorMarbre,
    MaterialId.SlabOutdoorNaturalStone,
    MaterialId.SlabOutdoorReconstituedStone,
    MaterialId.SlabOutdoorSlabGravel,
    MaterialId.SlabOutdoorTerracotta,
    MaterialId.SlabOutdoorTravertin,
    MaterialId.SlabOutdoorWood,
];

export const allTilesOutDoor: MaterialId[] = [
    MaterialId.TilesOutdoorBeigeStone,
    MaterialId.TilesOutdoorBlackMarble,
    MaterialId.TilesOutdoorBlackStone,
    MaterialId.TilesOutdoorConcreteBeige,
    MaterialId.TilesOutdoorConcreteBrown,
    MaterialId.TilesOutdoorConcreteDark,
    MaterialId.TilesOutdoorConcreteGrey,
    MaterialId.TilesOutdoorConcreteWhite,
    MaterialId.TilesOutdoorDarkWood,
    MaterialId.TilesOutdoorGreyMarble,
    MaterialId.TilesOutdoorGreyStone,
    MaterialId.TilesOutdoorGreyWood,
    MaterialId.TilesOutdoorLightWood,
    MaterialId.TilesOutdoorNaturalStone,
    MaterialId.TilesOutdoorWhiteMarble,
    MaterialId.TilesOutdoorWhiteStone,
];

export const allTerraceStone: MaterialId[] = [
    ...allConcretes,
    ...allSlabOutDoor,
    ...allTilesOutDoor,
    MaterialId.PavingStone,
];

export const allTerraceWood: MaterialId[] = [
    MaterialId.Pine,
    MaterialId.Ash,
    MaterialId.Teak,
    MaterialId.OakRegular,
    MaterialId.Douglas,
    MaterialId.Larch,
    MaterialId.Padouk,
    MaterialId.Redcedar,
    ...allCompositeWoods,
    MaterialId.Ipe,
    MaterialId.Cumaru,
    MaterialId.Garapa,
    MaterialId.Iroko,
    MaterialId.ThermoHeatedWoodAsh,
    MaterialId.ThermoHeatedWoodPine,
    MaterialId.Muiracatiara,
    MaterialId.Spruce,
];

export const allMirror: MaterialId[] = [
    MaterialId.AgedMirror,
    MaterialId.BronzeMirror,
    MaterialId.DarkGreyMirror,
    MaterialId.OneWayMirror,
    MaterialId.SilverMirror,
];

export const allFabric: MaterialId[] = [
    MaterialId.Fabric,
    MaterialId.FabricAcrylic,
    MaterialId.FabricMicroPerforated,
    MaterialId.FabricPolyester,
];

export const allNaturalFiber: MaterialId[] = [
    MaterialId.Ratan,
    MaterialId.Caning,
];

export const getMaterialsWithExceptions = (
    initialMaterials: MaterialId[],
    exceptedMaterials: MaterialId[],
): MaterialId[] => (
    initialMaterials.filter((initialMaterial) => !exceptedMaterials.includes(initialMaterial))
);

export default allMaterials;
